import React from 'react';
import Audit from '../svgs/audit';
import Automated from '../svgs/automated';
import QuickSupprt from '../svgs/quick-support';
import Training from '../svgs/training';
import Services from '../svgs/services';

const WebsiteDevelopment  = {
  "heroQuoteSection": {
      "enable": "true",
      "title": "ADA Compliance",
      "headline": "<strong>we help you make your web and apps accessible</strong> to every user.",
      "image": require('../images/accessibility/accesibility_img-1.png'),
      "position": "center", //center, left or rightM
      "btnGrad" : "lightBlue",
      "class": "move-from-left"
  },
  "textWithImage":{
    "enable": "true",
    "content": "We incorporate latest accessibility standards in our efficient & cost-effective solutions to help your business achieve accessibility.",
    "image": require('../images/accessibility/accesibility_img-2.png'),
    "position": "", //center, left or right
    "class": "bounce-up-down-2",
    "list": ['Website Review', 'Testing artifacts that are delivered', 'ADA Compliance', 'Recommendation', 'Remediation']
  },
  "headingWithIcons":{
    "enable": "true",
    "title": "Laws and standards",
    "adaIcons": [
      {
        "src": require('../images/accessibility/logo-1.png'),
        "alt": "ADA Network"
      },
      {
        "src": require('../images/accessibility/logo-2.png'),
        "alt": "ADA"
      },
      {
        "src": require('../images/accessibility/logo-3.png'),
        "alt": "ADA"
      },
      {
        "src": require('../images/accessibility/logo-4.png'),
        "alt": "WCAG"
      },
      {
        "src": require('../images/accessibility/logo-5.png'),
        "alt": "PDF Association"
      }
    ]
  },  
  "headingWithGrid":{
    "enable": "true",
    "title": "We are experts in",
    "blocks": [
      {
        "src": require('../images/accessibility/web-app-dev.jpg'),
        "title": "WEBSITE & APP DEVELOPMENT",
        "url": "e-commerce/seo"
      },
      {
        "src": require('../images/accessibility/desktop-app.jpg'),
        "title": "DESKTOP APP",
        "url": "e-commerce/smm"
      },
      {
        "src": require('../images/accessibility/mobile-app.jpg'),
        "title": "MOBILE APP",
        "url": "e-commerce/ppc"
      },
      {
        "src": require('../images/accessibility/pdfs.jpg'),
        "title": "PDFS",
        "url": "e-commerce/analytics"
      }
    ]
  },
  "iconsWithText":{
    "enable": "true",
    "title": "Key differentiators",
    "blocks": [
      {
        "src": <Audit class="zoom-in-out"/>,
        "title": "ADA AUDIT<br/><br>"
      },
      {
        "src": <Automated class="zoom-in-out"/>,
        "title": "AUTOMATED<br />TECHNIQUES"
      },
      {
        "src": <QuickSupprt class="zoom-in-out"/>,
        "title": "QUICK<br/>SUPPORT"
      },
      {
        "src": <Training class="zoom-in-out"/>,
        "title": "TRAINING<br/>PROGRAM"
      },
      {
        "src": <Services class="zoom-in-out"/>,
        "title": "UX<br/>SERVICES"
      }
    ]
  },
  "faq":{
    "enable": "false",
    "title": "Frequently asked questions",
    "questions": [
      {
        "key": 1,
        "q": "What is E-commerce website design?",
        "a": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      },
      {
        "key": 2,
        "q": "How to choose an E-commerce web development agency?",
        "a": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      },
      {
        "key": 3,
        "q": "How much does an e-commerce web design service cost?",
        "a": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      }
    ]
  }
};

export default WebsiteDevelopment;